const layout = () => import("../../internal/layout.vue");
const page = () => import("./index.vue");

const productsRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "products-labest",
      meta: {
        title: "Produtos Labest",
        requiresAuth: true,
      },
      component: page,
    },
  ],
};

export default productsRoutes;
